module.exports = __webpack_public_path__ + "img/2_19.c45e988f.jpg";